import React, {useEffect, useState} from 'react';
import {Modal} from "antd";
import server from "../../../../server";
import {getName} from "../../../../utility/utility";
import {Leave_Duration, Leave_Type} from "../../../../constant/constant";
import '../../../../styles/component/leave-audit-detail.scss'
import {useLeaveContext} from "./leaveContext";
import Locale from "../../../../core/locale/locale";
import dayjs from "dayjs";

export interface IRecord {
    id: string,
    name: string,
    session: string,
    date: string,
    leaveType: string,
    state: string
}

interface ILeaveAudit {
    record: IRecord,
}

interface IAudit {
    leaveRequestId: string,
    reason: string,
    state: string,
    name: string
    auditInfo: {
        createdOn: string,
        createdBy: string //email ID
    }
}

const LeaveAuditDetail: React.FC<ILeaveAudit> = (props) => {
    const record = props.record;
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [auditData, setAuditData] = useState([]);
    const {isAdmin} = useLeaveContext();

    useEffect(() => {
        if (record.id) {
            handleLeaveAudit(record.id)
        }
    }, [record])

    async function handleLeaveAudit(leaveId: string) {
        try {
            const res = await server.leave.request.getAudit(leaveId);
            const sortedList = res.sort((a: any, b: any) => {
                const dateA = new Date(a.createdOn).getTime();
                const dateB = new Date(b.createdOn).getTime();
                return dateA - dateB;
            });
            setAuditData(sortedList.map((item: any) => ({
                ...item,
                name: getName(item.actor.firstName, item.actor.middleName, item.actor.lastName)
            })));
            setIsOpen(true);

        } catch (e) {
            console.log('error ', e);
        }

    }

    return (
        <Modal
            title={'Leave Audit'}
            className={'hrms-app modal-audit'}
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={<></>}
        >
            <div className={'audit-container'}>
                <div className={'details-section'}>
                    <div className={"leave-audit leave-request-info-grid "}>
                        {isAdmin && <div className={'leave-audit info-cell '}>
                            <label className={'leave-audit cell-label'}>Employee Name</label>
                            <span className={'leave-audit cell-value '}>{record.name}</span>
                        </div>
                        }

                        <div className={'leave-audit info-cell '}>
                            <label className={'leave-audit cell-label'}>Leave Type</label>
                            <span
                                className={'leave-audit cell-value '}>{Leave_Type[record.leaveType as keyof typeof Leave_Type]}</span>
                        </div>
                        <div className={'leave-audit info-cell'}>
                            <label className={'leave-audit cell-label'}>Session</label>
                            <span
                                className={'leave-audit cell-value'}>{Leave_Duration[record.session as keyof typeof Leave_Duration]}</span>
                        </div>
                        <div className={'leave-audit info-cell'}>
                            <label className={'leave-audit cell-label'}>Leave Date</label>
                            <span
                                className={'leave-audit cell-value'}>{record.date ? dayjs(record.date).format(Locale.displayDate) : "-"}</span>
                        </div>
                    </div>
                </div>
                <div className={'section-divider'}/>
                <div className={'audit-details-section'}>
                    <h4 className={'section-title'}>Audit Details</h4>
                    <div className={'audit-timeline'}>
                        {auditData.map((audit: IAudit, index: number) => {
                            return (
                                <div key={index} className={'audit-item'}>
                                    <div className={'audit-item-header'}>
                                <span className={`status-badge status-${audit.state.toLowerCase().replace(' ', '-')}`}>
                                    {audit.state}
                                </span>
                                        <span className={'audit-date'}>
                                    {/*{new Date(audit.auditInfo.createdOn).toDateString()}*/}
                                            {audit.auditInfo.createdOn ? dayjs(audit.auditInfo.createdOn).format(Locale.displayDateWithMonth) : "-"}
                                </span>
                                    </div>
                                    <div className={'audit-item-content'}>
                                        <div className={'audit-field'}>
                                            <label className={'field-label'}>Action by</label>
                                            <span className={'field-value'}>{audit.auditInfo.createdBy}</span>
                                        </div>
                                        <div className={'audit-field'}>
                                            <label className={'field-label'}>Reason</label>
                                            <span className={'field-value'}>{audit.reason}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export default LeaveAuditDetail
